import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {EnumService} from 'src/app/api/module/erp/services/area-logada/enum/enum.service';
import {EntidadeConfig, EntidadeEnum} from 'src/app/api/module/erp/shared/enumerable/entidade.enum';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-reducao-carencia-proposta',
  templateUrl: './reducao-carencia-proposta.component.html',
  styleUrls: ['./reducao-carencia-proposta.component.scss'],
})
export class ReducaoCarenciaPropostaComponent implements OnInit {
  @Input() entidadeProposta: any;
  @Input() razaoSocialEntidade: any;
  @Input() codigoProposta: any;
  @Input() vigenciaProposta: any;
  formularioReducaoCarencia!: FormGroup<any>;
  @Input() mostrarQuadroDoisReducaoCarencia: any;
  @Input() listaBeneficiariosCarencias: any;
  @Input() nomeTitular: any;
  @Input() dadosOperadoraDM!: any;
  @Input() dadosOperadoraCabecalho!: any;
  @Input() beneficiarios = new Array<any>();
  @Input() modalidadeProduto = new Array<any>();

  @Input() heMedSenior: boolean = false;
  @Input() dataCriacaoProposta: any;

  operadoraVM: any;
  exibirNaFesp: boolean = false;
  udemo_e_apase: boolean = false;
  beneficiariosSemReducaoCarencia = new Array<any>();
  beneficiariosComReducaoCarencia = new Array<any>();
  listaEnumTipoCotacao!: any;
  inicioFiliacao: string = '';
  inicioCampanha: string = '';
  finalCampanha: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private _enumService: EnumService,
  ) {}

  ngOnInit(): void {
    this.getEnumContract();
    this.operadoraVM = this.carregarDadosOperadoraReducaoCarencia();
    this.adicionarDataCampanha();
    this.criarFormularioReducaoCarencia();
    this.preencher();
  }

  carregarDadosOperadoraReducaoCarencia(): string {
    const entidadeConfig = EntidadeConfig.getConfig(this.dadosOperadoraDM.branchCompanyName || '');

    // ESTIPULADO
    this.udemo_e_apase = entidadeConfig.tipo == EntidadeEnum.UDEMO || entidadeConfig.tipo == EntidadeEnum.APASE;
    this.exibirNaFesp = entidadeConfig.tipo == EntidadeEnum.ADSERVIP;

    const cnpjOperadoraFiltro = this.dadosOperadoraDM?.operatorObject && this.dadosOperadoraDM?.operatorObject?.cnpj;
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }

    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    return dadosOperadora;
  }

  criarFormularioReducaoCarencia() {
    this.formularioReducaoCarencia = this.formBuilder.group({
      analysisPeriodReductionCheck: new FormControl({
        value: null,
        disabled: true,
      }),
      modalityProduct: new FormControl(null),
    });
  }

  preencherFormularioReducacaoCarencia(listaBeneficiarios?: any) {
    this.beneficiarios = listaBeneficiarios;
    this.beneficiarios.forEach((item: any) => {
      if (!item.analysisPeriodReductionCheck) {
        this.beneficiariosSemReducaoCarencia.push(item.name);
      } else {
        this.beneficiariosComReducaoCarencia.push(item.name);
      }
    });
  }

  preencherFormularioReducaoCarenciaQuadroDois(modalidadeContrato: any) {
    this.formularioReducaoCarencia.patchValue({
      modalityProduct: modalidadeContrato,
    });
  }

  getEnumContract() {
    this._enumService.getEnumsContract().subscribe(data => {
      const tipoContratacao = data.find(
        (enumObj: {enumType: string}) => enumObj.enumType === 'ContractModalityProductEnum',
      );
      this.listaEnumTipoCotacao = tipoContratacao?.values || [];
    });
  }

  async preencher() {
    if (!this.dataCriacaoProposta) this.dataCriacaoProposta = this.dadosOperadoraDM.holderProposal.createDate;
    await this.separarBeneficiarios(this.dadosOperadoraDM);
    this.preencherFormularioReducacaoCarencia(this.beneficiarios);
    this.preencherFormularioReducaoCarenciaQuadroDois(this.dadosOperadoraDM?.modalityProduct);
  }

  async separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;

    if (beneficiario) {
      // TITULAR
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;

      const titularJaExiste = this.beneficiarios.some(b => b.id === dadosTitular.id);
      if (!titularJaExiste) {
        this.beneficiarios.push({
          ...dadosTitular,
          isDependent: false,
          proposalType: dados.proposalType,
        });
      }
      // DEPENDENTES
      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal.forEach((dependente: any) => {
          const dependenteJaExiste = this.beneficiarios.some(b => b.id === dependente.id);

          if (!dependenteJaExiste) {
            this.beneficiarios.push({
              ...dependente,
              isDependent: true,
            });
          }
        });
      }
    }
  }

  //mês 6 (aniversário fesp) mostra aditivo de campanha
  ehCampanhaAniversarioFesp(dataCriacaoProposta: any): boolean {
    return new Date(dataCriacaoProposta).getMonth() + 1 == 6 && this.beneficiariosSemReducaoCarencia.length > 0
      ? true
      : false;
  }

  isDataDentroDoPeriodo(): boolean {
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);

    const dataLimite = new Date(2026, 11, 1); // 01/12/2026
    dataLimite.setHours(0, 0, 0, 0);

    // Retorna true se a data atual for menor ou igual a 01/12/2026
    return dataAtual <= dataLimite;
  }

  adicionarDataCampanha() {
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    const anoAnterior = anoAtual - 1;

    if (this.ehCampanhaAniversarioFesp(dataAtual)) {
      this.inicioFiliacao = `01/06/${anoAnterior}`;
      this.inicioCampanha = `01/06/${anoAtual}`;
      this.finalCampanha = `30/06/${anoAtual}`;
    } else if (this.ehCampanhaUDEMO(dataAtual)) {
      this.inicioFiliacao = `01/10/${anoAnterior}`;
      this.inicioCampanha = `01/10/${anoAtual}`;
      this.finalCampanha = `30/10/${anoAtual}`;
    }
  }

  //mês 10 mostra aditivo de campanha UDEMO
  ehCampanhaUDEMO(dataCriacaoProposta: any): boolean {
    return new Date(dataCriacaoProposta).getMonth() + 1 == 10 &&
      this.beneficiariosSemReducaoCarencia.length > 0 &&
      this.udemo_e_apase
      ? true
      : false;
  }
}
